import AboutYouFormControl from 'purchase/checkout/AboutYouFormControl';
import customerTypeSelection from 'purchase/checkout/customerTypeSelection';
import linkAccountFormModal from 'purchase/checkout/linkAccount/linkAccountFormModal';

export default function aboutYou() {
	const aboutYouForm = document.getElementById('aboutYouForm');

	if (aboutYouForm) {
		new AboutYouFormControl(aboutYouForm);
		new window.od.PasswordStrength(aboutYouForm);
	}

	customerTypeSelection();

	linkAccountFormModal();
}
